import { useState } from 'react';

import { EditOutlined } from '@mui/icons-material';
import { IconButton } from '@mui/material';

import { DreConfigSubgruposModal } from 'pages/financeiro/dre/configuracao/components';
import { DreSubgrupo } from 'pages/financeiro/dre/configuracao/types';

export function DreConfigSubgruposEdit({ subgrupo }: { subgrupo: DreSubgrupo }) {
    const [openSubgruposModal, setOpenSubgruposModal] = useState(false);

    return (
        <>
            <DreConfigSubgruposModal subgrupo={subgrupo} open={openSubgruposModal} setOpen={setOpenSubgruposModal} />

            <IconButton sx={{ width: 30, height: 30 }} onClick={() => setOpenSubgruposModal(true)}>
                <EditOutlined />
            </IconButton>
        </>
    );
}
